import { useEffect, useRef, useState } from 'react'
import { Button, Card } from 'antd'
import { Order } from '../../Types/order.interface'
import './newOrder.component.scss'
import OrderItemModal from '../Modals/order item modal/orderItemModal'
import { axiosInstance } from '../../interceptor/axios_interceptor'

interface NewOrderProps {
  orders: Order[]
  restaurantLive: boolean
  reduxUser: any
  onOrderRemove: (orderId: string) => void // fully removes
  onOrderAcceptedFallback?: (orderId: string) => void // triggers polling fallback
}

const NewOrder = ({
  orders,
  restaurantLive,
  reduxUser,
  onOrderRemove,
  onOrderAcceptedFallback
}: NewOrderProps) => {
  const [visible, setVisible] = useState<boolean>(false)
  const [orderItem, setOrderItem] = useState<Order>()
  const itemRefs = useRef<(HTMLDivElement | null)[]>([])

  // Set up the effect to apply the "ringing" scale animation
  const scaleEffect = (index: number) => {
    const item = itemRefs.current[index]
    if (!item) return

    let scaleUp = true

    const animate = () => {
      // console.log('insideanimate')
      if (scaleUp) {
        item.style.transform = 'scale(1)'
        item.style.background = '#36b157'
        item.style.boxShadow = '0px 0px 4px 1px #36b157'
      } else {
        item.style.transform = 'scale(0.99)'
        // item.style.background = 'rgb(75, 175, 102)'
        item.style.boxShadow = '0px 0px 2px 1px rgb(75, 175, 102)'
      }
      scaleUp = !scaleUp

      // Recursively call this function to keep the effect going
      setTimeout(() => {
        requestAnimationFrame(animate)
      }, 200) // Adjust timing for speed of effect
    }

    animate()
  }

  useEffect(() => {
    console.log('orders:', orders)
    orders.forEach((_, index) => {
      scaleEffect(index)
    })
  }, [orders])

  const onShowOrderDetails = (orderItem: Order) => {
    setVisible(true)
    setOrderItem(orderItem)
    window.dispatchEvent(new Event('stopOrderAudio'))
  }

  const onAccept = async (orderItem: Order) => {
    setVisible(false)
    try {
      const orderAccepted = await axiosInstance.get(
        `/api/vendor/orderAccepted/${orderItem.orderId}`
      )
      if (orderAccepted.data.responseCode === 0) {
        console.log('orderAccepted')
        // Remove order from active list in parent component
        onOrderRemove(orderItem.orderId)
        
        // Start polling fallback in case websocket doesn't send updates
        if (onOrderAcceptedFallback) {
          onOrderAcceptedFallback(orderItem.orderId)
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  const onReject = async (orderItem: Order, reason: string) => {
    setVisible(false)
    try {
      const orderRejected = await axiosInstance.post(
        '/api/vendor/rejectOrder/',
        { orderId: orderItem.orderId, rejectReason: reason }
      )
      if (orderRejected.data.responseCode === 0) {
        console.log('orderRejected')
        // Remove order from active list in parent component
        onOrderRemove(orderItem.orderId)
      }
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <>
      {orderItem && (
        <OrderItemModal
          visible={visible}
          orderItem={orderItem}
          onAccept={onAccept}
          onReject={onReject}
        />
      )}
      {orders.map((order, index) => (
        <Card
          ref={(el) => {
            return (itemRefs.current[index] = el)
          }}
          className='card_order'
          key={order.orderId}
          style={{
            width: '100%',
            backgroundColor: '#36b157',
            marginBottom: '10px',
            transition: 'transform 0.8s ease'
          }}
        >
          <div
            className='item_container'
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              flexDirection: 'row',
              alignItems: 'center'
            }}
          >
            <p style={{ color: 'white', fontSize: 'large' }}>
              {order.orderType}
            </p>
            <Button
              className='showBtn'
              onClick={() => onShowOrderDetails(order)}
            >
              Show Details
            </Button>
          </div>
        </Card>
      ))}
    </>
  )
}

export default NewOrder
